import _ from 'lodash';

export const INFRA_THRESHOLD_URL = '/ipm/v1/admin/threshold';
export const CBQOS_CLASSES_URL = '/ngp/v2/cbqos-classes';
export const OPEN_TEST_TYPES_URL = '/ipm/v1/open/testTypes';
export const OPEN_TESTS_URL = '/ngp/v2/service-tests';
export const UPDATE_GLOBAL_THRESHOLDS_URL = '/ipm/v1/open/testTypes/updateGlobalThresholds';
export const ADMIN_TESTS_URL = OPEN_TESTS_URL;

export const INFRA_DEFAULTS = {
    Server: [
        { group: 'Server', metricIds: 0, degraded: 85, excessive: 98, min: 0, max: 100, units: '%' },
        { group: 'Server', metricIds: 1, degraded: 85, excessive: 98, min: 0, max: 100, units: '%' },
    ],
    Interface: [
        {
            group: 'Interface',
            metricIds: 0,
            degraded: 1,
            excessive: 1,
            enableDegraded: false,
            min: 0,
            max: 10000000,
            units: 'count per polling interval',
        },
        { group: 'Interface', metricIds: 1, degraded: 1, excessive: 5, min: 0, max: 100, units: '%' },
        { group: 'Interface', metricIds: 2, degraded: 70, excessive: 100, min: 0, max: 100, units: '%' },
    ],
    Wireless: [
        { group: 'Wireless', metricIds: 0, degraded: 30, excessive: 50, min: 0, max: 100, units: '%' },
        { group: 'Wireless', metricIds: 1, degraded: 30, excessive: 50, min: 0, max: 100, units: '%' },
        { group: 'Wireless', metricIds: 2, degraded: 50, excessive: 70, min: 0, max: 100, units: '%' },
        { group: 'Wireless', metricIds: 3, degraded: 50, excessive: 70, min: 0, max: 100, units: '%' },
    ],
    VMware: [
        { group: 'VMware', metricIds: 0, degraded: 85, excessive: 95, min: 0, max: 100, units: '%' },
        { group: 'VMware', metricIds: 1, degraded: 85, excessive: 95, min: 0, max: 100, units: '%' },
        { group: 'VMware', metricIds: 2, degraded: 20, excessive: 30, min: 0, max: 10000000, units: 'ms' },
    ],
    'Network Device': [
        { group: 'Network Device', metricIds: 0, degraded: 85, excessive: 95, min: 0, max: 100, units: '%' },
        { group: 'Network Device', metricIds: 1, degraded: 85, excessive: 95, min: 0, max: 100, units: '%' },
    ],
};

export async function getInfrastructureThresholds(dataService) {
    const response = await dataService.get(INFRA_THRESHOLD_URL);
    return response?.data || response || [];
}

export async function getCbQosClasses(dataService) {
    const response = await dataService.get(CBQOS_CLASSES_URL, {
        rowLimit: 10000,
        sort: 'name',
    });
    return response?.data || response || [];
}

export async function createMissingInfrastructureThresholds(dataService, allThresholds) {
    const groups = new Set((allThresholds || []).map((item) => item.group));
    const createRequests = [];

    _.forEach(INFRA_DEFAULTS, (defaults, group) => {
        if (groups.has(group)) return;

        defaults.forEach((config) => {
            createRequests.push(dataService.post(INFRA_THRESHOLD_URL, { ...config, group }));
        });
    });

    if (createRequests.length > 0) {
        await Promise.all(createRequests);
        return true;
    }

    return false;
}

export async function updateInfrastructureThreshold(dataService, thresholdId, value) {
    return dataService.put(`${INFRA_THRESHOLD_URL}/${thresholdId}`, {
        degraded: parseFloat(value.degraded),
        excessive: parseFloat(value.critical),
        metricId: value.metricId,
    });
}

export async function getTestTypes(dataService) {
    const response = await dataService.get(OPEN_TEST_TYPES_URL);

    const list = response?.data || response || [];
    return list.filter((testType) => !testType.hidden);
}

export async function getTestsByTypeIds(dataService, typeIds) {
    if (!typeIds || typeIds.length < 1) return [];

    const response = await dataService.get(OPEN_TESTS_URL, {
        query: JSON.stringify({ type: typeIds }),
    });

    return response?.data || response || [];
}

export async function updateGlobalThresholds(dataService, typeIds, payload) {
    return dataService.post(UPDATE_GLOBAL_THRESHOLDS_URL, payload, {
        query: JSON.stringify({ _id: typeIds }),
    });
}

export async function patchTestThresholdOverride(dataService, testId, payload) {
    return dataService.patch(`${ADMIN_TESTS_URL}/${testId}`, payload);
}

export async function updateCbQosClass(dataService, cbQosClass) {
    return dataService.patch(`${CBQOS_CLASSES_URL}/${cbQosClass._id}`, {
        enableMonitoring: cbQosClass.enableMonitoring,
        enableStatus: cbQosClass.enableStatus,
    });
}
